import * as React from 'react';
import Translate from '../../functions/translate';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const confirmDialog = (props) => {
  return (
    <Dialog
      open={props.isVisible}
      onClose={props.noClick}
    >
      <DialogTitle>
        {props.headerTitle}
      </DialogTitle>
      <DialogContent>
        {props.children}
      </DialogContent>
      <DialogActions>
        <div>
          <Button variant="contained" size="small" color="default" onClick={props.noClick} style={{ marginRight: '10px' }}>
            <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
            {Translate('No')}
          </Button>
          <Button variant="contained" size="small" color="primary" onClick={props.yesClick}>
            <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
            {Translate('Yes')}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default confirmDialog;